"use client";

import type { Prompt } from "@/lib/types";
import { createClient } from "@/lib/supabase/client";

interface PromptRow {
  id: string;
  title: string;
  description: string;
  category: string;
  price: number;
  thumbnail: string | null;
  images: unknown;
  prompt_text: string;
  tags: unknown;
  rating: number;
  review_count: number;
  author_name: string;
  author_avatar: string;
  created_at: string;
}

function normalizeStringArray(value: unknown): string[] {
  if (Array.isArray(value)) {
    return value.filter((v): v is string => typeof v === "string");
  }
  return [];
}

function toPrompt(row: PromptRow): Prompt {
  return {
    id: row.id,
    title: row.title,
    description: row.description,
    category: row.category,
    price: row.price,
    thumbnail: row.thumbnail ?? "",
    images: normalizeStringArray(row.images),
    prompt_text: row.prompt_text,
    author: {
      name: row.author_name,
      avatar: row.author_avatar,
    },
    tags: normalizeStringArray(row.tags),
    rating: Number(row.rating),
    reviewCount: row.review_count,
    createdAt: row.created_at,
  };
}

export async function fetchPromptsPublic(): Promise<Prompt[]> {
  const supabase = createClient();
  const { data, error } = await supabase.from("prompts").select("*");

  if (error) {
    throw new Error(error.message);
  }

  return ((data ?? []) as PromptRow[]).map(toPrompt);
}

export async function fetchPromptByIdPublic(id: string): Promise<Prompt | null> {
  const supabase = createClient();
  const { data, error } = await supabase
    .from("prompts")
    .select("*")
    .eq("id", id)
    .maybeSingle();

  if (error) {
    throw new Error(error.message);
  }

  if (!data) return null;
  return toPrompt(data as PromptRow);
}


